import React, { useContext, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import i18n from 'i18next';
import { MainContext } from '../../../context/main.context';
import { useTranslation } from 'react-i18next';

const RECAPTCHA_SITE_KEY: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string;


export default function Recaptcha(): JSX.Element | null {
    const { language } = i18n;
    const { t } = useTranslation();
    const { showCaptcha, failedAttemptCenter } = useContext(MainContext);
    const [ isLoaded, setIsLoaded ] = useState<boolean>(false);
    const [ captchaValue, setCaptchaValue ] = useState<string | null>('');

    useEffect((): void => {
        const captchaElem: HTMLElement| null = document.getElementById('recaptcha');

        if (captchaElem && isLoaded && !captchaValue) {
            captchaElem.style.border = '1px solid #dd4b39';
            captchaElem.style.padding = '5px';

            window.scrollTo(0, document.body.scrollHeight);
        }
    }, [ captchaValue, isLoaded ]);

    if (!showCaptcha) {
        return null;
    }

    const _setCaptchaValueState = (value: string | null): void => {
        setCaptchaValue(value);

        if (failedAttemptCenter && value) {
            failedAttemptCenter('reset');
        }
    }

    return (
        <div className="recaptcha-box">
            <ReCAPTCHA
                id="recaptcha"
                className="recaptcha"
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={(value: string | null): void => _setCaptchaValueState(value)}
                hl={language}
                asyncScriptOnLoad={() => setIsLoaded(true)}
            />
            {
                !captchaValue && isLoaded ?
                    <div className="recaptcha-error-message text-overflow">
                        {t('login.notRobot')}.
                    </div>
                : null
            }
        </div>
    )
};